module.exports = __webpack_public_path__ + "img/aips.c0335549.png";